import { DATE_FORMATS_FNS } from "components";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { CommunicationTemplatesQueryKeys } from "modules/CommunicationTemplates/queryKeys";
import { ApiInstance } from "utils/Api";
import { formatCurrentUTCDate } from "utils/dateHelperFunctions";

import type { GroupedCommunicationMedium } from "modules/CommunicationTemplates/queryKeys";

export const useDuplicateMediumMutation = () =>
  useTypedMutation<GroupedCommunicationMedium, number>({
    mutationFn: async payload => (await ApiInstance.post("/communication/mediums/duplicate", payload, ENV.dealerBaseURL)).data.communication_medium_id,
    onSuccess: (payload, communication_medium_id) => {
      const mediums = typedQueryClient.getQueryData(CommunicationTemplatesQueryKeys.getCommunicationMediums);
      if (!mediums?.length) return;

      const { variations: _variations, ...duplicatedMedium } = payload;

      typedQueryClient.setQueryData(
        CommunicationTemplatesQueryKeys.getCommunicationMediums,
        mediums.concat({
          ...duplicatedMedium,
          communication_medium_id,
          created_on: formatCurrentUTCDate(DATE_FORMATS_FNS.ISOFormatWithZ),
          updated_on: formatCurrentUTCDate(DATE_FORMATS_FNS.ISOFormatWithZ)
        })
      );
    }
  });
